import { header } from 'api/Auth/auth';
import axios from 'axios';
import { apiPaths } from 'constants/path';
import { IOauthApi, IDUserApi } from 'models/DCK/DCKApiTypes';
import { GetCompactListApiResopnse } from 'models/SignUp/signUpApiTypes';

class OauthApi {
    async getCompactList(): Promise<GetCompactListApiResopnse> {
        try {
            const response = await axios.get(apiPaths.compactList, {
                headers: header,
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    async oauth(rqData: { [key: string]: string | number | undefined }): Promise<IOauthApi> {
        try {
            const response = await axios.post(apiPaths.signUp, rqData, {
                headers: header,
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    }
}
export const oauthApi = new OauthApi();
